export const APPLICATION_URLS = {
  GET_SINGLE_USER_DETAIL: '/user',
  GET_ALL_APPLICATION: '/application-form/all',
  GET_SINGLE_APPLICATION_HEALTH: '/application-form/health',
  GET_ALL_REQUEST: '/application/request',
  GET_ALL_OPTION: '/application/request-option/request_option-by-request',
  GET_ALL_PRODUCT: 'product/products-by-request_option',
  GET_ALL_BILL_RECIPIENT_WITH_INCOME:
    '/application-form/bill_recipient/with_income',
  GET_ALL_BILL_RECIPIENT_WITHOUT_INCOME:
    'application-form/bill_recipient/without_income',
  GET_SINGLE_BILL_RECIPIENT: '/application-form/bill_recipient/:application_id',
  GET_ALL_CHILDREN: '/application-form/children',
  GET_SINGLE_APPLICATION_EDUCATION: '/application-form/education',
  GET_SINGLE_WITH_HOUSE_HOLD_INCOME: '/basic-data/with-income',
  GET_SINGLE_WITHOUT_HOUSEHOLD_INCOME: '/basic-data/without-income',
  CREATE_STATUS_APPLICATION_HEALTH: '/application-form/health/change_status',
  CREATE_STATUS_APPLICATION_EDUCATION:
    '/application-form/education/change_status',
  CHANGE_APPLICATION_STATUS:
    '/application-form/admin/change_status/:application_id'
};
